import React from 'react';
import clsx from 'clsx';
import {withStyles} from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import HomeIcon from '@material-ui/icons/Home';
import PeopleIcon from '@material-ui/icons/People';
import DnsRoundedIcon from '@material-ui/icons/DnsRounded';
import HelpIcon from '@material-ui/icons/Help';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import {Link} from "react-router-dom";
import {logout, setNavigationDrawer} from "../actions/session";
import {connect} from "react-redux";
import Typography from "@material-ui/core/Typography";
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import SettingsEthernetIcon from '@material-ui/icons/SettingsEthernet';
import KeyIcon from '@material-ui/icons/VpnKey';

const userMenu = [
  {
    id: 'Menu',
    children: [
      {id: 'Home', icon: <HomeIcon/>, active: true, to: "/dashboard"},
      {id: 'My Profile', icon: <PeopleIcon/>, to: "/dashboard/profile"},
      {id: 'Search Database', icon: <DnsRoundedIcon/>, to: "/dashboard/query"},
      {id: 'Support', icon: <HelpIcon/>, to: "/dashboard/support"},
      {id: 'Change Password', icon: <KeyIcon/>, to: "/dashboard/changePassword"}
    ],
  },
];

const adminMenu = [
  {
    id: 'Admin',
    children: [
      {id: 'Users', icon: <PeopleIcon/>, to: "/dashboard/admin/users"},
      {id: 'Connections', icon: <FavoriteBorderIcon/>, to: "/dashboard/admin/connections"},
      {id: 'Tags', icon: <SettingsEthernetIcon/>, to: "/dashboard/admin/tags"},
      {id: 'Invite', icon: <MailOutlineIcon/>, to: "/dashboard/admin/invite"},
      {id: 'Content Manager', icon: <MailOutlineIcon/>, to: "/dashboard/admin/contentManager"},
      // {id: 'QueryBeta', icon: <DnsRoundedIcon/>, to: "/dashboard/queryTest"},
    ],
  },
];

const styles = theme => ({
  categoryHeader: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  categoryHeaderPrimary: {
    color: theme.palette.common.white,
  },
  item: {
    paddingTop: 1,
    paddingBottom: 1,
    color: 'rgba(255, 255, 255, 0.7)',
    '&:hover,&:focus': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  },
  itemCategory: {
    backgroundColor: '#232f3e',
    boxShadow: '0 -1px 0 #404854 inset',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  firebase: {
    fontSize: 24,
    color: theme.palette.common.white,
  },
  itemActiveItem: {
    color: '#4fc3f7',
  },
  itemPrimary: {
    fontSize: 'inherit',
  },
  itemIcon: {
    minWidth: 'auto',
    marginRight: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(2),
  },
});

let Navigator = (props) => {
  const {classes, ...other} = props;
  const handleLogout = () => {
    props.logout();
  };

  const handleClick = (e) => {
    props.closeNavDrawer();
    const selectedId = e.target.innerHTML;
    userMenu.forEach(category => {
      category.children.forEach(child => {
        if (child.id === selectedId) {
          child.active = true;
        } else {
          child.active = false;
        }
      })
    });

    adminMenu.forEach(category => {
      category.children.forEach(child => {
        if (child.id === selectedId) {
          child.active = true;
        } else {
          child.active = false;
        }
      })
    });

  };

  return (
    <Drawer variant="permanent" {...other} open={props.open}>
      <List disablePadding>
        <ListItem
          className={clsx(classes.item, classes.itemCategory)}
        >
          <ListItemText
            classes={{
              primary: classes.itemPrimary,
            }}
          >
            <Typography> </Typography>
          </ListItemText>
        </ListItem>
        {userMenu.map(({id, children}) => (
          <React.Fragment key={id}>
            <ListItem className={classes.categoryHeader}>
              <ListItemText
                classes={{
                  primary: classes.categoryHeaderPrimary,
                }}
              >
                {id}
              </ListItemText>
            </ListItem>
            {children.map(({id: childId, icon, active, to}) => (
              <ListItem
                key={childId}
                button
                className={clsx(classes.item, active && classes.itemActiveItem)}
                to={to}
                component={Link}
                onClick={(e) => handleClick(e)}
              >
                <ListItemIcon className={classes.itemIcon}>{icon}</ListItemIcon>
                <ListItemText
                  classes={{
                    primary: classes.itemPrimary,
                  }}
                >
                  {childId}
                </ListItemText>
              </ListItem>
            ))}
          </React.Fragment>
        ))}
        {
          props.isAdmin ? (
            adminMenu.map(({id, children}) => (
              <React.Fragment key={id}>
                <ListItem className={classes.categoryHeader}>
                  <ListItemText
                    classes={{
                      primary: classes.categoryHeaderPrimary,
                    }}
                  >
                    {id}
                  </ListItemText>
                </ListItem>
                {children.map(({id: childId, icon, active, to}) => (
                  <ListItem
                    key={childId}
                    button
                    className={clsx(classes.item, active && classes.itemActiveItem)}
                    to={to}
                    component={Link}
                    onClick={(e) => handleClick(e)}
                  >
                    <ListItemIcon className={classes.itemIcon}>{icon}</ListItemIcon>
                    <ListItemText
                      classes={{
                        primary: classes.itemPrimary,
                      }}
                    >
                      {childId}
                    </ListItemText>
                  </ListItem>
                ))}
              </React.Fragment>
            ))
          ) : null
        }
        <Divider className={classes.divider}/>
        <ListItem
          key='Sign out'
          button
          className={clsx(classes.item, classes.itemPrimary)}
          onClick={handleLogout}
        >
          <ListItemIcon className={classes.itemIcon}><ExitToAppIcon/></ListItemIcon>
          <ListItemText
            classes={{
              primary: classes.itemPrimary,
            }}
          >
            Sign out
          </ListItemText>
        </ListItem>
      </List>
    </Drawer>
  );
};

const mapStateToProps = (state) => {
  const {session, setNavigationDrawer} = state;

  return {
    isAdmin: Boolean("admin" === session.role),
    setNavigationDrawer,
    open: Boolean(state.ui.navigationDrawerStatus)
  }
};

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
  closeNavDrawer: () => dispatch(setNavigationDrawer(false))
});

Navigator = withStyles(styles)(Navigator);

Navigator = connect(
  mapStateToProps,
  mapDispatchToProps
)(Navigator);

export default Navigator
